"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _FormContext = _interopRequireDefault(require("./FormContext"));
const FormCheckbox = _ref => {
  let {
    className,
    checked,
    onChange
  } = _ref;
  const {
    controlId
  } = _react.default.useContext(_FormContext.default);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValue)(checked, false);
  const onInputChange = event => {
    const newValue = event.target.checked === true;
    setInternalValue(newValue);
    if ((0, _ark.isFunction)(onChange)) onChange(newValue, event);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('formCheck', checked ? 'formCheck-checked' : null, className)
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: controlId,
    type: "checkbox",
    className: "checkbox",
    onChange: onInputChange,
    checked: internalValue ?? false
  }));
};
process.env.NODE_ENV !== "production" ? FormCheckbox.propTypes = {
  className: _propTypes.default.string,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : void 0;
FormCheckbox.defaultProps = {
  className: undefined,
  checked: false,
  onChange: undefined
};
var _default = exports.default = FormCheckbox;